import type { AuthInfo, GetTokenFn, RequestInterceptorFn } from '../types';

export interface AuthRequestInterceptorOptions {
  /** 各 app 提供不同的 token 来源 */
  getToken: GetTokenFn;
  /** 自定义 Authorization header 格式，默认 `token ${userId} ${key}` */
  formatToken?: (auth: AuthInfo) => string;
}

export const createAuthRequestInterceptor = (
  options: AuthRequestInterceptorOptions,
): RequestInterceptorFn => {
  return async config => {
    // 已有 Authorization 则跳过
    if (config.headers.get('Authorization')) {
      return config;
    }

    const auth = await options.getToken();
    if (auth) {
      const value = options.formatToken
        ? options.formatToken(auth)
        : `token ${auth.userId} ${auth.key}`;
      config.headers.set('Authorization', value);
    }

    return config;
  };
};
